import { useCallback } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Listable } from 'listable'
import Row from './row'
import { useNavigate } from 'react-router-dom'
import Filters from '../filters'
import { actions, config, constants } from '../../module'


const List = ({ model }) => {

  const navigate = useNavigate()

  const renderItem = useCallback((item, index, itemProps) => {

    const isNonTfmVehicle = item.agreementNo.includes('UNF')
    const onView = () => navigate(
      `${constants.PATH_DRILLDOWN}/${item.agreementNo}/${isNonTfmVehicle ? 'contract-details' : 'variations'}`
    )

    return (
      <Row key={index} item={item} onView={onView} {...itemProps}/>
    )
  }, [navigate])

  // Prevents re-rendering if ids or data updated - no longer needed
  const { ids, filters, ...rest } = model

  return (
    <Listable
      actions={actions}
      config={config}
      filters={Filters}
      model={rest}
      renderItem={renderItem}/>
  )
}

List.propTypes = {
  model: PropTypes.object.isRequired,
}

const mapStateToProps = ({ reportKmTracking }) => ({
  model: reportKmTracking,
})

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(List)
